import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Center, chakra, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';
import { RouteT } from 'shared/routes';
import useGetColors from 'shared/hooks/useGetColors';

interface Props {
  route: RouteT,
}

const SidebarLink = ({ route }: Props) => {
  //   Chakra color mode
  const location = useLocation();
  const activeColor = useColorModeValue('gray.900', 'white');
  const inactiveColor = useColorModeValue('secondaryGray.600', 'secondaryGray.600');
  const activeIcon = useColorModeValue('brand.500', 'white');
  const textColor = useColorModeValue('secondaryGray.500', 'white');
  // const brandColor = useColorModeValue('brand.500', 'brand.400');
  const { blue500 } = useGetColors();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName.toLowerCase());
  };


  return (
    <NavLink to={route.isDisabled ? '#' : `/${route.layout}/${route.path}`}>
      {route.icon ? (
        <Box>
          <HStack
            // spacing={activeRoute(route.path) ? '22px' : '26px'}
            borderRadius="8px"
            // boxShadow={activeRoute(route.path) ? "0px 1px 2px 0px rgba(0,0,0,0.06), 0px 1px 3px 0px rgba(0,0,0,0.1)" : "none"}
            bg={activeRoute(route.path) ? "white" : 'transparent'}
            p={2}
            position="relative"
          >
            <Flex w='100%' gap={4} alignItems='center' justifyContent='center'>
              <Center
                color={activeRoute(route.path) ? activeIcon : textColor}>
                {route.icon}
              </Center>
              <Text
                me='auto'
                color={activeRoute(route.path) ? activeColor : textColor}
                fontWeight="500"
              >
                {route.name}
              </Text>
            </Flex>
            {activeRoute(route.path) && <chakra.span position="absolute" right="-16px" borderRadius="25px" w="4px" height="36px" backgroundColor={blue500} />}
          </HStack>
        </Box>
      ) : (
        <Box>
          <HStack
            // spacing={activeRoute(route.path) ? '22px' : '26px'}
            borderRadius="8px"
            // boxShadow={activeRoute(route.path) ? "0px 1px 2px 0px rgba(0,0,0,0.06), 0px 1px 3px 0px rgba(0,0,0,0.1)" : "none"}
            bg={activeRoute(route.path) ? "white" : 'transparent'}
            p='8px'>
            <Text
              me='auto'
              color={activeRoute(route.path) ? activeColor : inactiveColor}
              fontWeight="500"
            >
              {route.name}
            </Text>
          </HStack>
        </Box>
      )}
    </NavLink>
  );
}

export default SidebarLink;
